const CHICAGO_AREAS = [
  'Lincoln Park', 'Wicker Park', 'Logan Square', 'Hyde Park',
  'Pilsen', 'Bridgeport', 'Bronzeville', 'Rogers Park',
  'Lakeview', 'Andersonville', 'Humboldt Park', 'South Loop',
];

const SUBURBS = [
  'Evanston', 'Oak Park', 'Naperville', 'Schaumburg',
  'Cicero', 'Berwyn', 'Joliet', 'Arlington Heights',
  'Bolingbrook', 'Orland Park', 'Aurora', 'Elgin',
];

export default function AreasServedSection() {
  return (
    <section id="areas" className="py-24 md:py-32 bg-blue-950 relative overflow-hidden">
      {/* Bg image */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/aac8e9d3faea1900ec3b6d16e091e0cc.jpg"
          alt="Chicago area map"
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="text-red-400 text-xs font-semibold tracking-widest uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
            Service Area
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" style={{ fontFamily: "'Oswald', sans-serif" }}>
            SERVING GREATER <span className="text-blue-400">CHICAGOLAND</span>
          </h2>
          <p className="text-gray-400 text-base max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
            Butler Frelix Construction LLC proudly serves homeowners and businesses across the greater Chicagoland area — from the heart of the city to the surrounding suburbs.
          </p>
        </div>

        {/* Areas Grid */}
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {/* Chicago Neighborhoods */}
            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-8 h-8 flex items-center justify-center bg-red-700 rounded-lg">
                  <i className="ri-building-line text-white text-sm" />
                </div>
                <h3 className="text-white font-black text-xl" style={{ fontFamily: "'Oswald', sans-serif" }}>
                  CHICAGO NEIGHBORHOODS
                </h3>
              </div>
              <div className="grid grid-cols-2 gap-y-3">
                {CHICAGO_AREAS.map((area) => (
                  <div key={area} className="flex items-center gap-2">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-map-pin-2-fill text-red-500 text-xs" />
                    </div>
                    <span className="text-gray-300 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>{area}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Suburbs */}
            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-8 h-8 flex items-center justify-center bg-red-700 rounded-lg">
                  <i className="ri-home-smile-line text-white text-sm" />
                </div>
                <h3 className="text-white font-black text-xl" style={{ fontFamily: "'Oswald', sans-serif" }}>
                  CHICAGOLAND SUBURBS
                </h3>
              </div>
              <div className="grid grid-cols-2 gap-y-3">
                {SUBURBS.map((area) => (
                  <div key={area} className="flex items-center gap-2">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-map-pin-2-fill text-red-500 text-xs" />
                    </div>
                    <span className="text-gray-300 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>{area}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Callout */}
          <div className="mt-10 bg-red-700/20 border border-red-500/30 rounded-xl px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-question-line text-red-400 text-xl" />
              </div>
              <p className="text-red-200 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                Not sure if we serve your area? Our service area is always expanding — reach out and ask!
              </p>
            </div>
            <button
              onClick={() => {
                const el = document.querySelector('#contact');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-red-700 hover:bg-red-800 text-white font-semibold text-sm px-6 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
